const tabs = require(MODULES_PATH + '/tabs');

new tabs({ selectorClass: 'sectors-tabs' });
